var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordChanged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 200,
    viewBox: "0 0 300 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5489 122.336C79.3618 142.964 123.404 180.928 171.41 160.839C193.736 151.495 190.668 139.753 206.683 122.396C216.229 112.05 230.543 103.561 233.431 89.5544C235.926 77.4648 232.533 65.0403 225.522 57.4101C209.755 40.25 180.238 30.2572 155.059 61.9906C129.879 93.7239 76.458 69.1359 78.5489 122.336V122.336Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2881 66.7135C74.1397 73.5871 82.5746 74.5315 96.0878 73.2255C106.251 72.2412 115.518 71.4796 125.682 65.9381C132.796 62.0623 138.427 56.8186 142.537 51.7255C146.991 46.2079 153.208 39.911 150.16 33.6551C145.972 25.0613 121.753 17.8236 98.2359 29.6598C72.4019 42.6654 66.5205 59.9956 70.2881 66.7135Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9537 87.333C48.9379 92.2855 62.1895 85.9173 62.1895 85.9173C62.1895 85.9173 59.2445 71.522 49.2549 66.5761C39.2706 61.6233 26.0244 67.9846 26.0244 67.9846C26.0244 67.9846 28.9694 82.3802 38.9537 87.333V87.333Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.665 102.763C257.241 106.014 249.458 103.009 249.458 103.009C249.458 103.009 250.476 94.733 255.904 91.4856C261.328 88.2346 269.107 91.2362 269.107 91.2362C269.107 91.2362 268.09 99.5117 262.665 102.763V102.763Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7117 158.107C65.4054 158.107 66.7784 156.734 66.7784 155.041C66.7784 153.347 65.4054 151.974 63.7117 151.974C62.018 151.974 60.645 153.347 60.645 155.041C60.645 156.734 62.018 158.107 63.7117 158.107Z",
    fill: "#E1E4E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M263.432 136.745C265.878 136.745 267.861 134.762 267.861 132.315C267.861 129.869 265.878 127.886 263.432 127.886C260.985 127.886 259.002 129.869 259.002 132.315C259.002 134.762 260.985 136.745 263.432 136.745Z",
    fill: "#E1E4E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0957 128.093C49.9575 128.093 51.4667 126.584 51.4667 124.722C51.4667 122.861 49.9575 121.351 48.0957 121.351C46.2339 121.351 44.7246 122.861 44.7246 124.722C44.7246 126.584 46.2339 128.093 48.0957 128.093Z",
    fill: "#E1E4E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9693 39.1519C69.0393 39.1519 70.7174 37.4738 70.7174 35.4038C70.7174 33.3337 69.0393 31.6556 66.9693 31.6556C64.8993 31.6556 63.2212 33.3337 63.2212 35.4038C63.2212 37.4738 64.8993 39.1519 66.9693 39.1519Z",
    fill: "#E1E4E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272.199 59.0745C272.199 60.9334 273.706 62.4403 275.565 62.4403C277.424 62.4403 278.931 60.9334 278.931 59.0745C278.931 57.2157 277.424 55.7088 275.565 55.7088C273.706 55.7088 272.199 57.2157 272.199 59.0745Z",
    fill: "#E1E4E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M176.902 31.1412C179.375 31.1412 181.38 29.1366 181.38 26.6639C181.38 24.1911 179.375 22.1865 176.902 22.1865C174.429 22.1865 172.425 24.1911 172.425 26.6639C172.425 29.1366 174.429 31.1412 176.902 31.1412Z",
    fill: "#E1E4E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3657 108.804C62.268 108.804 63.8101 107.57 63.8101 106.049C63.8101 104.527 62.268 103.293 60.3657 103.293C58.4635 103.293 56.9214 104.527 56.9214 106.049C56.9214 107.57 58.4635 108.804 60.3657 108.804Z",
    fill: "#E1E4E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237.95 39.0981H237.901C237.611 43.2148 234.549 43.278 234.549 43.278C234.549 43.278 237.925 43.344 237.925 48.1006C237.925 43.344 241.301 43.278 241.301 43.278C241.301 43.278 238.241 43.2148 237.95 39.0981V39.0981ZM243.079 146.854H243.032C242.753 150.958 239.814 151.021 239.814 151.021C239.814 151.021 243.055 151.087 243.055 155.829C243.055 151.087 246.296 151.021 246.296 151.021C246.296 151.021 243.358 150.958 243.079 146.854Z",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.828 177.509C192.544 177.509 227.172 142.882 227.172 100.166C227.172 57.4505 192.544 22.8226 149.828 22.8226C107.113 22.8226 72.4849 57.4505 72.4849 100.166C72.4849 142.882 107.113 177.509 149.828 177.509Z",
    fill: "#A9162A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 22,
    width: 156,
    height: 156
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.828 177.509C192.544 177.509 227.172 142.882 227.172 100.166C227.172 57.4505 192.544 22.8226 149.828 22.8226C107.113 22.8226 72.4849 57.4505 72.4849 100.166C72.4849 142.882 107.113 177.509 149.828 177.509Z",
    fill: "#A9162A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.195 65.4088H108.805C101.858 65.4088 96.2263 71.0405 96.2263 77.9874V166.667C96.2263 173.614 101.858 179.245 108.805 179.245H191.195C198.142 179.245 203.773 173.614 203.773 166.667V77.9874C203.773 71.0405 198.142 65.4088 191.195 65.4088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.704 153.145H167.296M124.38 125.318H175.587H124.38ZM124.38 139.21H175.587H124.38Z",
    stroke: "#E1E4E5",
    strokeWidth: 4.53805,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.958 86.7924L145.296 109.413L131.698 95.8409",
    stroke: "#A9162A",
    strokeWidth: 8.62893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 138.055,
    y1: 240.852,
    x2: 181.318,
    y2: -104.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 96.2337,
    y1: 111.26,
    x2: 130.562,
    y2: -42.9956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 77.2942,
    y1: 102.782,
    x2: -5.05609,
    y2: 37.6421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 241.674,
    y1: 113.228,
    x2: 285.322,
    y2: 72.6733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChanged);
export default __webpack_public_path__ + "static/media/PasswordChanged.f4f7cc2d6ca15c10a3c75f7a25ece263.svg";
export { ForwardRef as ReactComponent };